import { Avatar, Dropdown } from "antd";
import { GeneralStore } from "../../stores";
import { UserOutlined } from "@ant-design/icons";
import { ProfileMenuItems } from "../../layouts/constants/SidebarData";

export const ProfileDropdown = () => {
  const { user } = GeneralStore();
  const profileMenuItems = ProfileMenuItems();
  return (
    <Dropdown
      trigger={["click"]}
      menu={{ items: profileMenuItems }}
      placement="bottomRight"
    >
      <div className="flex items-center gap-2 mr-2 hover:bg-gray-100 rounded-lg p-2.5 duration-300 cursor-pointer">
        <Avatar src={"user?.imageUrl"} size={36} icon={<UserOutlined />} />
        <div className=" inline-flex flex-col justify-center h-fit *:leading-2 md:*:leading-4">
          <span className=" text-[11px] md:text-[14px] m-0 p-0">
            {user && user?.userAndLastName}
          </span>
          <span className="text-[8px] md:text-[10px] m-0 p-0 ">
            {user && user?.role}
          </span>
        </div>
      </div>
    </Dropdown>
  );
};
